import { setUserCountry as _setUserCountry } from '@griply/services';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const setUserCountry = async () => {
  await _setUserCountry({ functions: getFunctions(), httpsCallable });
};
